import React from 'react';
import { Link } from 'react-router-dom';
import vaultEvents from '../data/vaultEvents';
import './Pages.css';

const TheVault = () => {
  return (
    <div className="page-container">
      <div className="vault-container">
        <h1 className="vault-main-title">THE VAULT</h1>
        <h2 className="vault-subtitle">CLICK ON A POSTER BELOW TO SEE MORE</h2>
        
        <div className="vault-grid">
          {/* Map through vault events data to create grid items */}
          {vaultEvents.map((event) => (
            <Link 
              to={`/vault/${event.id}`} 
              key={event.id} 
              className="vault-grid-item"
            >
              <img 
                src={require(`../assets/posters/${event.posterImage}`)} 
                alt={event.title} 
                className="vault-poster"
              />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TheVault; 